import {makeStyles} from '@material-ui/core/styles';

export default function Badge({ value, color, style }) {
  const styles = makeStyles(() => ({
    badge: {
      backgroundColor: color || '#ff9800',
      color: '#fff',
      padding: '5px 10px',
      borderRadius: 20,
      fontSize: '1rem',
      fontWeight: 'bold',
    },
  }))

  const classes = styles()

  return (
    <div className={classes.badge} style={style}>
      <span>{value}</span>
    </div>
  )
}
